export enum TemplateType {
  HOME = 'index',
  COLLECTION = 'collection',
  PRODUCT = 'product',
  ARTICLE = 'article',
  BLOG = 'blog',
  PAGE = 'page',
}

export type GPV6TemplateType =
  | 'template-page'
  | 'template-article'
  | 'template-index'
  | 'template-product'
  | 'template-collection';
export enum ProviderSource {
  GEMPAGESV7 = 'GEMPAGESV7',
  GEMPAGESV6 = 'GEMPAGESV6',
  SHOPIFY = 'SHOPIFY',
  SHOPIFY_GEMX = 'SHOPIFY_GEMX',
  SHOPIFY_PAGE_FLY = 'SHOPIFY_PAGE_FLY',
  SHOPIFY_FOXIFY = 'SHOPIFY_FOXIFY',
  SHOPIFY_ECOMPOSER = 'SHOPIFY_ECOMPOSER',
  SHOPIFY_ORIGIN = 'SHOPIFY_ORIGIN',
}
export interface IProviderConfig {
  label: string;
  thumbnail: string;
  prefix?: string;
  isMapping?: boolean;
  logo: IconProps;
  pathName?: string;
}
export type IconProps = {
  icon?: string;
  iconViewBox?: string;
};

export interface ParseTemplateProps {
  assetKey: string;
  providerSourceInfo: Omit<ProviderSourceInfo, 'parseTemplate'>;
}

export interface ProviderSourceInfo {
  providerSource: ProviderSource;
  regex: RegExp;
  regexId?: RegExp;
  parseTemplate: (augments: ParseTemplateProps) => TemplateInfo | undefined;
}
export interface TemplateInfo {
  type: TemplateType;
  suffix: string;
  fileExtension?: 'json' | 'liquid';
  providerSource?: ProviderSource;
}

export interface BuildQueryParamsInApp {
  version: 'v6' | 'v7';
  pageId: string;
  shopifyDomain?: string;
}
export interface BuildQueryParamsInAppV6 extends BuildQueryParamsInApp {
  pageHandle?: string;
  pageType?: GPV6TemplateType;
}
